module.exports = __webpack_public_path__ + "static/media/dst-on@2x.7179c5f4.webp";